<div *ngIf="dvc.pages[0]" class="row nomargin">
  <ul id="dataviewer_sortable" [sortablejs]="dvc.pages[0].layers" [sortablejsOptions]="options" style="width:100%; background-color:#ffffff; max-height:100%; list-style: none outside none; font-size:0.9em;padding:0px;  margin: 0px;cursor: pointer;">
    <li *ngFor="let layer of dvc.pages[0].layers; index as i;"  [ngClass]="{'layer-selected' : layer.selected}" style="text-decoration:none;padding:10px;padding-right:5px;border-top:1px solid #cccccc;">
      <wol-layerlist-item [layer]="layer" [index]="i"></wol-layerlist-item>
    </li>
  </ul>
</div>
